import React from 'react';

import { useMonth } from '@datepicker-react/hooks';
import classNames from 'classnames';

import DatepickerDay from '../datepicker-day/datepicker-day';

import './datepicker-month.scss';

interface DatepickerMonthProps {
  year: number;
  month: number;
  firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined;
}

const weekLabels = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

const DatepickerMonth: React.FC<DatepickerMonthProps> = ({
  year,
  month,
  firstDayOfWeek,
}) => {
  const { days } = useMonth({
    year,
    month,
    firstDayOfWeek,
  });

  return (
    <div className="datepicker-month">
      <div className="datepicker-month__week-labels">
        {weekLabels.map((label, index) => (
          <div
            key={label + index}
            className={classNames('week-label-item', {
              'week-label-item--holiday': label === 'Сб' || label === 'Вс',
            })}
          >
            {label}
          </div>
        ))}
      </div>
      <div className="datepicker-month__grid">
        {days.map((item, index) => {
          if (typeof item === 'object') {
            return (
              <DatepickerDay
                dayLabel={item.dayLabel.toString()}
                key={item.date.toString() + index}
                date={item.date}
              />
            );
          }
          return <div key={index} />;
        })}
      </div>
    </div>
  );
};

export default DatepickerMonth;
